import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from 'questionizer-core'
import styles from './index.scss?inline'
import './index.scss'

//let configPath = document!.querySelector('meta[name="febis-questionizer-config-url"]')?.getAttribute('content');
import config from "./config.json"

if (config !== undefined) {
  const host = document.getElementById('febis-questionizer');
  if (host){
    // @font-face must be in light DOM — browsers don't load fonts from Shadow DOM stylesheets
    if (!document.getElementById('gc-contor-klavika-fonts')) {
      const fontStyle = document.createElement('style');
      fontStyle.id = 'gc-contor-klavika-fonts';
      const fontBase = (config.baseurl || '').replace(/\/+$/, '') + '/fonts/';
      fontStyle.textContent = `
        @font-face { font-display: swap; font-family: 'GCKlavika'; font-style: normal; font-weight: 300; src: url('${fontBase}GCKlavika-Light.woff2') format('woff2'), url('${fontBase}GCKlavika-Light.woff') format('woff'); }
        @font-face { font-display: swap; font-family: 'GCKlavika'; font-style: normal; font-weight: 400; src: url('${fontBase}GCKlavika-Regular.woff2') format('woff2'), url('${fontBase}GCKlavika-Regular.woff') format('woff'); }
        @font-face { font-display: swap; font-family: 'GCKlavika'; font-style: normal; font-weight: 500; src: url('${fontBase}GCKlavika-Medium.woff2') format('woff2'), url('${fontBase}GCKlavika-Medium.woff') format('woff'); }
        @font-face { font-display: swap; font-family: 'GCKlavika'; font-style: normal; font-weight: 700; src: url('${fontBase}GCKlavika-Bold.woff2') format('woff2'), url('${fontBase}GCKlavika-Bold.woff') format('woff'); }
      `;
      document.head.appendChild(fontStyle);
    }

    const shadow = host.attachShadow({ mode: 'open' });
    const mountPoint = document.createElement('div');
    
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styles);
    shadow.adoptedStyleSheets = [sheet];

    console.log("ADOPTED",sheet,  shadow.adoptedStyleSheets);

    shadow.appendChild(mountPoint);

      ReactDOM.createRoot(mountPoint).render(
      <React.StrictMode>
        <App config={config}/>
      </React.StrictMode>);
    }
  }else{
    console.warn("Keine Konfiguration gefunden");
  }